import { clientStatuses } from "../../../constants";
import "../../Tax Pro Only/ClientStatus/ClientStatus.scss";
import "./ClientStatusBadge.scss";

interface ClientStatusBadgeProps {
  status: string;
}

const ClientStatusBadge = ({ status }: ClientStatusBadgeProps) => {
  const getStatusInfo = (isText: boolean) => {
    const statusItem = clientStatuses[status as keyof typeof clientStatuses];
    if (statusItem === undefined) {
      return isText ? "Unknown" : "unknown";
    }
    return isText ? statusItem?.status : statusItem?.class;
  };

  return (
    <>
      <div className={`badge statusClass-${getStatusInfo(false)}`}>
        {getStatusInfo(true)}
      </div>
    </>
  );
};

export default ClientStatusBadge;
